export const DASHBOARD_ERROR_VIEW_TRANSLATION_KEY = 'user-panel-error-view';
